
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myaccount/credits",
      function () {
        return require("private-next-pages/myaccount/credits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myaccount/credits"])
      });
    }
  